require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-is-the-connection-between-climate-change-and-disability.json") })
        }
      }, "path---en-us-update-what-is-the-connection-between-climate-change-and-disability");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-is-the-connection-between-climate-change-and-disability!./.cache/json/en-us-update-what-is-the-connection-between-climate-change-and-disability.json
// module id = 844
// module chunks = 231608221292675